import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getItemBasic } from '../Api'

export default generateApiAction({
  baseType: Types.ITEMS.GET.BASIC,
  api: getItemBasic,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/items/GetBasicAction.js